
export { V2FTMigrationSuccessSnackbar } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/web/src/ui/v2ft-migration/V2FTMigrationSuccessSnackbar.tsx"